import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserPermissionServiceProxy, AddressDto, ToRequestCityDto, ToRequestDistrictDto, UserPermissionAddressDto } from '../../../../../../../../../shared/service-proxies/service-proxies';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { TestService } from 'test/service/test.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

@Component({
  selector: 'kt-to-request-add-address-to-person-category',
  templateUrl: './to-request-add-address-to-person-category.component.html',
  styleUrls: ['./to-request-add-address-to-person-category.component.scss']
})
export class ToRequestAddAddressToPersonCategoryComponent implements OnInit, OnDestroy {

	//Lokasyon inputunun formControl bilgisini tutar
	myControl = new FormControl();

	//lokasyon listesini tutar ve değişiklikler bunun içerisine aktarılır.
	filteredOptions: Observable<any[]>;

	//Dataları yayınladığımız değişken
	dynamicComponentObject = new Subject<any>();
	
	//combobox seçilmediğinde ekranda görinecek hata mesajları
	isRequiredCityMessage: boolean = null;
	isRequiredDistrictMessage: boolean = null;
	isRequiredAddressMessage: boolean = null;
	isRequiredFullAddressMessage: boolean = null;

	//Fulladres yeri disabled yapabilmek kullandık.
	isFullAddress: boolean = null;


	//toRequestAddressPtoSelect: ToRequestAddressPto = new ToRequestAddressPto();

	//Seçilen lokasyonun objesini tutar.
	selectedTargetLocationObj;


	cities = new BehaviorSubject<ToRequestCityDto[]>([]);
	districts = new BehaviorSubject<ToRequestDistrictDto[]>([]);
	districtlist: ToRequestDistrictDto[] = [];
	locations = new BehaviorSubject<UserPermissionAddressDto[]>([]);
	locationList: UserPermissionAddressDto[] = [];

	selectCityId;
	selectDistrictId;
	selectAddress;
	selectFullAddress;


	constructor(
		private _userPermissionService: UserPermissionServiceProxy,
		private _testService: TestService,
		private customLocalization: CustomLocalizationService
	) { }


	ngOnInit() {

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.ADDADDRESSTOPERSONCATEGORY.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.TOREGIONWAREHOUSE.ADDADDRESSTOPERSONCATEGORY.SUBHEADER"));



		//Component yüklemeye başlandığı anda kullanıcı bazlı olarak adresleri getirir.
		//this.getAddressByUserAuths();

		this.getUserAssignedCityAndDistrictListForAddAddress();
	}

	private getUserAssignedCityAndDistrictListForAddAddress() {

		this._userPermissionService.getUserAssignedCityAndDistrictListForAddAddress()
			.subscribe(result => {
				this.cities.next(result.cities);
				this.districtlist = result.districts;

				console.log("adres sayfasında ki il ve ilçe bilgileri" + result);

			})
	}

	private setFieldEmpty(district, address, fullAddress, filteredOptions, selectedTargetLocationObj ) {

		this.selectDistrictId = district;
		this.selectAddress = address;
		this.selectFullAddress = fullAddress;
		this.filteredOptions = filteredOptions;
		this.selectedTargetLocationObj = selectedTargetLocationObj;

	}

	//Şehir combosunda bir şehir seçildiğinde ya da değiştiğinde
	//buradan ilçeleri yülklüyoruz seçilen şehire göre
	onChangeCity() {

		this.setFieldEmpty(0, "", "", new Observable<any[]>(), "");

		//this.setFieldEmpty("", "", "", new Observable<any[]>(),"");
	
		//seçili olan şehiri yakaladık.
		var currentCityId = this.selectCityId;

		if (currentCityId > 0) {
			//seçili olan şehir ait ilçeleri filtreleyip alıyoruz
			var currentDistrictId = this.districtlist.filter(x => x.cityId == currentCityId);

			//ilçeleri asenkron listemize atıyoruz.
			this.districts.next(currentDistrictId);
		}
		

		this.SendToObject();
	}

	onChangeDistrict() {


		this.setFieldEmpty(this.selectDistrictId, "", "", new Observable<any[]>(), "");
		
		var currentDistrictId = this.selectDistrictId;

		if (currentDistrictId > 0) {
			
			this.getUserCitiesAddressWithUserAssignedAddressesForAddAddress();
		}

		

		this.SendToObject();
		
	}

	//lokasyonları ekran basan listemizdir.
	private getUserCitiesAddressWithUserAssignedAddressesForAddAddress() {

		this._userPermissionService
			.getUserAddAddressToCityAuthCitiesAddresses(this.selectCityId, this.selectDistrictId)
			.subscribe(result => {

				console.log("lokasyon bilgilerimi: " + result);

				this.locations.next(result);
				this.locationList = result;

				this.autoCompleteFilter();
			});

	}
	
	//Kullanıcı eğer combobox iiçerisinden bir lokasyon seçmez ise ve eliyle lokasyon yazarsa bu method içerisine giriyor.
	//Eski değerleri siliyoruz.
	//yayınlayıxı içerisine gönderiyoruz dynamic component içerisinden değişikliği anlık olarak yakalamak için.
	onKeyupCustomAddress() {

		this.isFullAddress = false;
		this.selectedTargetLocationObj = null;
		this.selectFullAddress;

		this.isRequiredMessageHandling(this.isRequiredAddressMessage, this.selectFullAddress);

		this.SendToObject();

	}

	//Kullanıcı eğer combobox içerisinde ki lokasyonu seçerse bu methoda giriyoruz.
	onClickSelectedLocation(option) {

		this.selectFullAddress = option.fullAddress;
		this.selectedTargetLocationObj = option;

		//Adres alanını disables özelliğini aktifleştirmek için kullandıkç
		this.isFullAddress = true;

		this.SendToObject();

	}



	//Adres alanını temsil eder.
	//Kullanıcı lokasyon içerisine elle bir lokasyon girerse açık adres yerinede yeni
	//bir açık adres girebilir bunu burada yakalıyoruz ve önceki değeri temizliyoruz.
	onBlurFullAddress() {
		this.selectedTargetLocationObj = "";

		//elle girilen adres datasını tutar 
		this.selectFullAddress;

		this.SendToObject();

	}


	//Parent component içerisine gönderilen datalarımız.
	private SendToObject() {
		
		this.dynamicComponentObject.next({

			city: this.selectCityId,
			district: this.selectDistrictId,
			targetAddress: this.selectedTargetLocationObj,
			targetCustomAddress: this.selectAddress,
			address: this.selectFullAddress

		});

	}


	isRequiredMessageHandling(messageLocation: boolean = null, ngModelName: any) {

		//Hata mesajının görünmesi için ekledik.
		!ngModelName ? messageLocation = true : "";

	}

	//myControlyani lokasyonun alduğu yerde herhangi bir değişiklik olursa bu methoda sokuyruz ve filtereleme işlemi yapıyoruz.
	private autoCompleteFilter() {


		this.filteredOptions = this.myControl.valueChanges.pipe(
			startWith<string | UserPermissionAddressDto>(""),
			map((value) => (typeof value === "string" ? value : value.name)),
			map((name) =>
				name ? this.filter(name) : this.locationList.slice()
			)
		);

	}

	//Aradığımız kelime filtreleyip burada tekrar filterelenmiş listeyi bize dönderir.
	filter(name: string) {
		return this.locationList.filter(
			(option) =>
				option.name.toLowerCase().indexOf(name.toLowerCase()) === 0
		);
	}

	ngOnDestroy() {
		this._testService.setTitle(" ");
		this._testService.setDesc(" ");

		this.dynamicComponentObject.unsubscribe();

	}

}
